@switch (mediaToDisplay$().type) {
  @case (fileType.ImageSvg) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImagePng) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImageJpeg) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImageGif) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.AudioMp3) {
    <ng-container [ngTemplateOutlet]="videoMedia"></ng-container>
  }
  @case (fileType.VideoMp4) {
    <ng-container [ngTemplateOutlet]="videoMedia"></ng-container>
  }
}

<ng-template #videoMedia>
  <video
    #videoEl
    controls
    controlsList="nodownload noplaybackrate"
    disablepictureinpicture
    oncontextmenu="return false;"
    [autoplay]="autoplay()"
    class="stimulus-viewer__video"
    [class.isExpanded]="isExpanded()"
  >
    <source [src]="mediaToDisplay$().url" [type]="mediaToDisplay$().type" />
    Your browser does not support the video tag.
  </video>
</ng-template>

<ng-template #imageMedia>
  <!-- <pinch-zoom [disableZoomControl]="'disable'"> -->
  @if (mediaToDisplay$().url) {
    <img
      oncontextmenu="return false;"
      [id]="mediaToDisplay$().mediaId"
      [alt]="mediaToDisplay$().name"
      [ngSrc]="mediaToDisplay$().url"
      fill
      class="stimulus-viewer__image"
      [class.isExpanded]="isExpanded()"
      priority
    />
  }
  <!-- </pinch-zoom> -->
</ng-template>
